$dependencyManager.addDependenciesCallback(['gsap', 'scrollTrigger'], () => {
  class AccentLine {
    constructor(parent) {
      this.parent = parent;

      // Check if the parent already has a container
      if (this.parent.find('.mad-accent-line__container').length > 0) {
        return;  // If it does, skip creating a new accent line
      }

      // Create the container div
      this.container = jQuery('<div>', {
        class: 'mad-accent-line__container'
      });

      // Check if the parent has the class 'mad-accent-line__parent--small'
      if (this.parent.hasClass('mad-accent-line__parent--small')) {
        this.container.addClass('mad-accent-line__container--small');
      }

      // Check if the parent has the class 'mad-accent-line__parent--no-animation'
      if (this.parent.hasClass('mad-accent-line__parent--no-animation')) {
        this.container.addClass('mad-accent-line__container--no-animation');
      }

      // Create the main accent line div
      this.mainLine = jQuery('<div>', {
        class: 'mad-accent-line mad-accent-line--main'
      });
      this.container.append(this.mainLine);

      // Create the three square accent line divs
      this.squareLines = [];
      for (let i = 0; i < 4; i++) {
        const squareLine = jQuery('<div>', {
          class: 'mad-accent-line mad-accent-line--square'
        });
        this.container.append(squareLine);
        this.squareLines.push(squareLine);
      }

      // Append the container to the parent element
      this.parent.append(this.container);

      // Set up the GSAP animation for the lines
      this.setupAnimation();
    }

    setupAnimation() {
      // Check if the parent has the class 'mad-accent-line__parent--no-animation'
      if (this.parent.hasClass('mad-accent-line__parent--no-animation')) {
        return;
      }

      // Create a timeline for the animation
      const tl = gsap.timeline({
        paused: true,
        defaults: {
          ease: 'power2.out',
        },
      });

      // Add animations to the timeline
      tl.set(this.mainLine, {
          x: '-100%',
          opacity: 1
        }) // Set initial state off screen to the left
        .to(this.mainLine, {
          duration: 0.45,
          delay: 0.25,
          x: '0%'
        }) // Animate to the final position
        .fromTo(this.squareLines[0], {
          opacity: 0
        }, {
          duration: 0.2,
          opacity: 1,
          delay: 0
        })
        .fromTo(this.squareLines[1], {
          opacity: 0
        }, {
          duration: 0.2,
          opacity: 1,
          delay: 0.05
        })
        .fromTo(this.squareLines[2], {
          opacity: 0
        }, {
          duration: 0.2,
          opacity: 1,
          delay: 0.1
        })
        .fromTo(this.squareLines[3], {
          opacity: 0
        }, {
          duration: 0.2,
          opacity: 1,
          delay: 0.1
        });

      // Create ScrollTrigger to control the timeline
      ScrollTrigger.create({
        trigger: this.parent,
        start: 'top 80%',
        end: 'center 20%',
        onEnter: () => {
          tl.play();
        },
        onLeaveBack: () => {
          tl.reverse();
        },
        onEnterBack: () => {
          tl.play();
        },
        onLeave: () => {
          tl.reverse();
        },
        markers: false,
        delay: 0.5
      });
    }
  }

  jQuery('.mad-accent-line__parent').each((index, element) => {
    new AccentLine(jQuery(element));
  });
});
